import { theme, styled, utils } from 'ui/theme';

import { SIZE } from './Scrollbar.enums';

export const scrollPosition = '--scroll-position';
export const scrollSize = `--scroll-size`;

export const Scrollbar = {
  Component: styled('div')`
    background: ${theme.colors.action.navigation.standard.disabled};
    overflow: hidden;
    position: relative;
    width: 100%;

    /* SIZES */
    &[data-size=${SIZE.SMALL}] {
      height: ${theme.sizes[1]};
      border-radius: ${theme.radii.small};
    }

    &[data-size=${SIZE.MEDIUM}] {
      height: ${theme.sizes[4]};
      border-radius: ${theme.radii.medium};
    }

    &[data-size=${SIZE.LARGE}] {
      height: ${theme.sizes[8]};
      border-radius: ${theme.radii.large};
    }
  `,

  Scroll: styled('div')`
    ${utils.transition('transform').easing('easeOut').duration('shortest')};
    background: ${theme.colors.action.navigation.standard.static};
    border-radius: ${theme.radii.small};
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    transform: ${`translate3D(var(${scrollPosition}), 0, 0)`};
    width: ${theme.sizes[6]};

    &[data-size='true'] {
      width: ${`var(${scrollSize})`};
    }

    /* COLORS */
    &[data-color='primary'] {
      background: ${theme.colors.build.brand1};
    }

    &[data-color='secondary'] {
      background: ${theme.colors.build.brand2};
    }

    &[data-color='darkLight'] {
      background: ${theme.colors.build.darkLight};
    }

    &[data-color='medium'] {
      background: ${theme.colors.build.mediumMedium};
    }

    &[data-color='disabled'] {
      background: ${theme.colors.action.navigation.standard.disabled};
    }

    &[data-color='error'] {
      background: ${theme.colors.status.error.standard};
    }

    &[data-color='success'] {
      background: ${theme.colors.status.success.standard};
    }

    &[data-color='alert'] {
      background: ${theme.colors.status.alert.standard};
    }
  `,
};
